module.exports = __webpack_public_path__ + "img/lazhu.b7f69e6d.gif";